import { Layout } from "@singularsystems/neo-canvas-grid";

export default class AccrualScheduleHelper {

    public static getLayout() {
        return {
            "root": {
                "headerLines": 2,
                "color": 1,
                "children": {
                    "details": {
                        "headerLines": 2,
                        "columns": [
                            {
                                "key": "rate",
                                "suppressTotal": true
                            },
                            {
                                "key": "interestRate",
                                "suppressTotal": true
                            },
                            {
                                "key": "calculationRate",
                                "total": {
                                    "type": "weightedAverage",
                                    "relatedColumn": "capital"
                                }
                            },
                            {
                                "key": "capital",
                                "suppressTotal": true
                            },
                            {
                                "key": "compoundedBalance",
                                "suppressTotal": true
                            },
                            {
                                "key": "expectedDividend",
                                "total": {
                                    "type": "sum"
                                }
                            },
                            {
                                "key": "dividendReceived",
                                "total": {
                                    "type": "sum"
                                }
                            }
                        ]
                    }
                }
            }
        } as Layout.IGridLayout;
    }
}